import type { SplitAnswerPair } from "./types";

export const splitAnswerPair: SplitAnswerPair = (answers) => {
  const substantive = answers.filter((answer) => answer.tone !== "quiet");
  const wayOuts = answers.filter((answer) => answer.tone === "quiet");

  if (substantive.length !== 2 || wayOuts.length > 1) return null;

  const [approve, reject] = substantive;
  // A tick can only ever mean "accept it as it stands". An ask whose leading
  // answer does something else — "show me the run they belong on" — has no yes
  // in it, and a tick drawn over it would be inventing one.
  if (approve.action.kind !== "accept") return null;

  return { approve, reject, wayOut: wayOuts[0] ?? null };
};
